import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import history from './history';
import 'antd/dist/antd.css';

import Layout from './components/Layout';
import NotFoundError from './pages/NotFoundError';
import HeroBannerForm from './pages/HeroBanner/HeroBannerForm';
import WebCardsList from './pages/WebCards/WebCardsList';
import WebCardsForm from './pages/WebCards/WebCardsForm';
import MegaphoneBannerForm from './pages/MegaphoneBanner/MegaphoneBannerForm';
import MobileCardsList from './pages/MobileCards/MobileCardsList';
import MobileCardsForm from './pages/MobileCards/MobileCardsForm';
import './App.css';

function App() {
  return (
    <div className="App">
      <Router history={history}>
        <Layout>
          <Switch>
            <Route path="/" exact component={WebCardsList} />
            <Route path="/hero-banner/update" exact component={HeroBannerForm} />
            <Route path="/cards" exact component={WebCardsList} />
            <Route path="/cards/create" exact component={WebCardsForm} />
            <Route path="/cards/edit/:id" exact component={WebCardsForm} />
            <Route path="/megaphone-banner/update" exact component={MegaphoneBannerForm} />
            <Route path="/mobile/cards" exact component={MobileCardsList} />
            <Route path="/mobile/cards/create" exact component={MobileCardsForm} />
            <Route component={NotFoundError} />
          </Switch>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
